import React from "react"

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import Button from "@mui/material/Button"
import Fab from "@mui/material/Fab"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"

import NdButton from "@components/common/NdComponents/NdButton"

import {DropDownItems, DropDownMenuProps} from "src/utils/@types/DropdownInterface"

function DropDownMenuLight({
    topCard,
    bottomCard,
    isClassic,
    button,
    isFab,
    className,
    disabled,
    noPadding,
    style,
    force,
    items
}: Readonly<DropDownMenuProps>) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClick = (clickFunction: () => void) => {
        setAnchorEl(null)
        clickFunction()
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const renderMenuClass = () => {
        return `${topCard ? "topCard" : ""}${bottomCard ? " bottomCard" : ""}`
    }

    let ButtonType: React.ReactNode

    if (isClassic) {
        ButtonType = (
            <NdButton
                buttonstyle="primary"
                size="medium"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
            >
                {button}
                <KeyboardArrowDownIcon />
            </NdButton>
        )
    } else if (isFab) {
        ButtonType = (
            <Fab
                color="primary"
                variant="extended"
                onClick={handleMenuClick}
                style={{display: "flex", justifyContent: "space-between"}}
            >
                {button}
            </Fab>
        )
    } else {
        ButtonType = (
            <Button
                className={className ? className : "clearStyleBtn"}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
                disabled={disabled}
                style={{
                    ...style,
                    fontSize: 14,
                    height: "100%",
                    padding: noPadding ? 0 : undefined
                }}
            >
                {button}
            </Button>
        )
    }

    return (
        <>
            {force && (
                <>
                    {ButtonType}
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        className={renderMenuClass()}
                        MenuListProps={{
                            "aria-labelledby": "simple-button"
                        }}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left"
                        }}
                    >
                        {topCard || null}
                        {items.length > 0 &&
                            items.map((item: DropDownItems, index: number) => (
                                <MenuItem
                                    key={item.key + "_" + index}
                                    onClick={() => handleClick(item.click)}
                                    style={{
                                        justifyContent: "flex-start",
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: 10
                                    }}
                                >
                                    {item?.icon && item.icon}
                                    {item.text}
                                </MenuItem>
                            ))}
                        {bottomCard || null}
                    </Menu>
                </>
            )}
            {!force && (
                <>
                    {items.length >= 1 && button !== "" && (
                        <>
                            {ButtonType}
                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                className={renderMenuClass()}
                                MenuListProps={{
                                    "aria-labelledby": "simple-button"
                                }}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left"
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left"
                                }}
                            >
                                {topCard || null}
                                {items.map((item: DropDownItems, index: number) => (
                                    <MenuItem
                                        key={item.key + "_" + index}
                                        onClick={() => handleClick(item.click)}
                                        style={{
                                            justifyContent: "flex-start",
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: 10
                                        }}
                                    >
                                        {item?.icon && item.icon}
                                        {item.text}
                                    </MenuItem>
                                ))}
                                {bottomCard || null}
                            </Menu>
                        </>
                    )}
                    {items.length === 1 && button === "" && (
                        <NdButton
                            buttonstyle="primary"
                            size="medium"
                            title={items[0].title}
                            onClick={() => items[0].click()}
                        >
                            {items[0].text}
                        </NdButton>
                    )}{" "}
                </>
            )}
        </>
    )
}

export default DropDownMenuLight
